import { useAuth } from '../context/AuthContext';
import {
  useSchedulesSchedulesByTeamMemberRetrieveQuery,
  useTeamsTeamMembersMemberAppointmentsRetrieveQuery,
  useTeamsTeamMembersMemberSalonsRetrieveQuery,
  useTeamsTeamMembersUserServicesRetrieveQuery,
  useTeamsTeamMembersUserTeamsRetrieveQuery
} from '../services/GLOWClient';

/**
 * Hook for accessing schedules with permission control
 * Employees can only access their own schedules
 */
export const usePermissionControlledSchedulesQuery = (args, options) => {
  const { user, isEmployee, teamMemberId } = useAuth();
  
  // If user is an employee, override the teamMemberId parameter with their own
  const queryArgs = isEmployee() && teamMemberId 
    ? { teamMemberId } 
    : args;
  
  // Skip the query if user is an employee but we don't have their teamMemberId yet
  const queryOptions = isEmployee() && !teamMemberId
    ? { ...options, skip: true }
    : options;
  
  return useSchedulesSchedulesByTeamMemberRetrieveQuery(queryArgs, queryOptions);
};

/**
 * Hook for accessing team member appointments with permission control
 * Employees can only access their own appointments
 */
export const usePermissionControlledMemberAppointmentsQuery = (args, options) => {
  const { user, isEmployee, teamMemberId } = useAuth();
  
  // If user is an employee, override the teamMemberId parameter with their own
  const queryArgs = isEmployee() && teamMemberId
    ? { ...args, teamMemberId }
    : args;
  
  // Skip the query if user is an employee but we don't have their teamMemberId yet
  const queryOptions = isEmployee() && !teamMemberId
    ? { ...options, skip: true }
    : options;
  
  return useTeamsTeamMembersMemberAppointmentsRetrieveQuery(queryArgs, queryOptions);
};

/**
 * Hook for accessing team member salons with permission control
 * Employees can only access their own salon assignments
 */
export const usePermissionControlledMemberSalonsQuery = (args, options) => {
  const { user, isEmployee, teamMemberId } = useAuth();
  
  // If user is an employee, override the teamMemberId parameter with their own
  const queryArgs = isEmployee() && teamMemberId
    ? { teamMemberId }
    : args;
  
  // Skip the query if user is an employee but we don't have their teamMemberId yet
  const queryOptions = isEmployee() && !teamMemberId
    ? { ...options, skip: true }
    : options;
  
  return useTeamsTeamMembersMemberSalonsRetrieveQuery(queryArgs, queryOptions);
};

/**
 * Hook for accessing user services with permission control
 * Employees can only access their own services
 */
export const usePermissionControlledUserServicesQuery = (args, options) => {
  const { user, isEmployee } = useAuth();
  
  // If user is an employee, override the userId parameter with their own
  const queryArgs = isEmployee() && user
    ? { userId: user.id }
    : args;
  
  // Skip the query if user is an employee but we don't have their user ID yet
  const queryOptions = isEmployee() && !user
    ? { ...options, skip: true }
    : options;
  
  return useTeamsTeamMembersUserServicesRetrieveQuery(queryArgs, queryOptions);
};

/**
 * Hook for accessing user teams with permission control
 * Employees can only access their own teams
 */
export const usePermissionControlledUserTeamsQuery = (args, options) => {
  const { user, isEmployee } = useAuth();
  
  // If user is an employee, override the userId parameter with their own
  const queryArgs = isEmployee() && user
    ? { userId: user.id }
    : args;
  
  // Skip the query if user is an employee but we don't have their user ID yet
  const queryOptions = isEmployee() && !user
    ? { ...options, skip: true }
    : options;
  
  return useTeamsTeamMembersUserTeamsRetrieveQuery(queryArgs, queryOptions);
};
